/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M10 8.14286L6.93042 6.16956C5.3245 5.13718 4.52153 4.62099 3.85752 4.66841C3.27885 4.70974 2.74665 5.0003 2.39897 5.46471C2 5.99762 2 6.95219 2 8.86133V15.1387C2 17.0478 2 18.0024 2.39897 18.5353C2.74665 18.9997 3.27885 19.2903 3.85752 19.3316C4.52153 19.379 5.3245 18.8628 6.93042 17.8304L10 15.8571"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.9304 17.8304C13.3245 18.8628 12.5215 19.379 11.8575 19.3316C11.2789 19.2903 10.7466 18.9997 10.399 18.5353C10 18.0024 10 17.0478 10 15.1387V8.86133C10 6.95219 10 5.99762 10.399 5.46471C10.7466 5.0003 11.2789 4.70974 11.8575 4.66841C12.5215 4.62099 13.3245 5.13718 14.9304 6.16956L19.8128 9.30823C21.2063 10.2041 21.9031 10.652 22.1438 11.2216C22.3541 11.7192 22.3541 12.2808 22.1438 12.7784C21.9031 13.348 21.2063 13.7959 19.8128 14.6918L14.9304 17.8304Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path
					d="M14.9304 17.8304C13.3245 18.8628 12.5215 19.379 11.8575 19.3316C11.2789 19.2903 10.7466 18.9997 10.399 18.5353C10 18.0024 10 17.0478 10 15.1387V8.86133C10 6.95219 10 5.99762 10.399 5.46471C10.7466 5.0003 11.2789 4.70974 11.8575 4.66841C12.5215 4.62099 13.3245 5.13718 14.9304 6.16956L19.8128 9.30823C21.2063 10.2041 21.9031 10.652 22.1438 11.2216C22.3541 11.7192 22.3541 12.2808 22.1438 12.7784C21.9031 13.348 21.2063 13.7959 19.8128 14.6918L14.9304 17.8304Z"
					fill="currentColor"
				/>
				<path
					d="M8.53042 16.8019C9.06723 16.4568 9.33564 16.2842 9.53017 16.0531C9.70237 15.8485 9.83178 15.6115 9.91077 15.356C10 15.0673 10 14.7483 10 14.1101V9.8899C10 9.25174 10 8.93266 9.91077 8.64403C9.83178 8.38855 9.70237 8.1515 9.53017 7.9469C9.33564 7.71577 9.06723 7.54322 8.53042 7.19813L6.93042 6.16956C5.3245 5.13718 4.52153 4.62099 3.85752 4.66841C3.27885 4.70974 2.74665 5.0003 2.39897 5.46471C2 5.99762 2 6.95219 2 8.86133V15.1387C2 17.0478 2 18.0024 2.39897 18.5353C2.74665 18.9997 3.27885 19.2903 3.85752 19.3316C4.52153 19.379 5.3245 18.8628 6.93042 17.8304L8.53042 16.8019Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M10 8.14286L6.93042 6.16956C5.3245 5.13718 4.52153 4.62099 3.85752 4.66841C3.27885 4.70974 2.74665 5.0003 2.39897 5.46471C2 5.99762 2 6.95219 2 8.86133V15.1387C2 17.0478 2 18.0024 2.39897 18.5353C2.74665 18.9997 3.27885 19.2903 3.85752 19.3316C4.52153 19.379 5.3245 18.8628 6.93042 17.8304L10 15.8571M19.8128 14.6918L14.9304 17.8304C13.3245 18.8628 12.5215 19.379 11.8575 19.3316C11.2789 19.2903 10.7466 18.9997 10.399 18.5353C10 18.0024 10 17.0478 10 15.1387V8.86133C10 6.95219 10 5.99762 10.399 5.46471C10.7466 5.0003 11.2789 4.70974 11.8575 4.66841C12.5215 4.62099 13.3245 5.13718 14.9304 6.16956L19.8128 9.30823C21.2063 10.2041 21.9031 10.652 22.1438 11.2216C22.3541 11.7192 22.3541 12.2808 22.1438 12.7784C21.9031 13.348 21.2063 13.7959 19.8128 14.6918Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M6.18042 4.79578C4.5745 3.7634 3.77153 3.24721 3.10752 3.29463C2.52885 3.33596 1.99665 3.62652 1.64897 4.09093C1.25 4.62384 1.25 5.57841 1.25 7.48755V16.5124C1.25 18.4215 1.25 19.3761 1.64897 19.909C1.99665 20.3734 2.52885 20.664 3.10752 20.7053C3.77153 20.7527 4.5745 20.2365 6.18042 19.2042L9.25 17.2309C9.25 18.5102 9.25 19.1498 9.43422 19.5488C9.80375 20.3491 10.6536 20.8131 11.5266 20.6912C11.9619 20.6304 12.4999 20.2845 13.5761 19.5927L21.1997 14.6917C22.5933 13.7959 23.2901 13.348 23.5307 12.7784C23.741 12.2808 23.741 11.7192 23.5307 11.2215C23.2901 10.652 22.5933 10.204 21.1997 9.3082L13.5761 4.40726C12.4999 3.71546 11.9619 3.36956 11.5266 3.30878C10.6536 3.18685 9.80375 3.65085 9.43422 4.45113C9.25 4.8501 9.25 5.48976 9.25 6.76908L6.18042 4.79578Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M8.75 15.8571V8.86133C8.75 6.95219 8.75 5.99762 9.14897 5.46471C9.49665 5.0003 10.0289 4.70974 10.6075 4.66841C11.2715 4.62099 12.0745 5.13718 13.6804 6.16956L13.75 6.21429M8.75 15.8571V15.8571C8.75 17.1365 8.75 17.7761 8.93422 18.1751C9.30374 18.9754 10.1536 19.4394 11.0266 19.3174C11.4619 19.2567 11.9999 18.9108 13.0761 18.219L18.5628 14.6918C19.9563 13.7959 20.6531 13.348 20.8938 12.7784C21.1041 12.2808 21.1041 11.7192 20.8938 11.2216C20.6531 10.652 19.9563 10.2041 18.5628 9.30823L17.25 8.46429M8.75 15.8571L5.68042 17.8304C4.0745 18.8628 3.27153 19.379 2.60752 19.3316C2.02885 19.2903 1.49665 18.9997 1.14897 18.5353C0.75 18.0024 0.75 17.0478 0.75 15.1387V7.75523C0.75 6.81264 0.75 6.34135 0.851055 6.03563C1.18137 5.03633 2.22965 4.46403 3.24886 4.72655C3.56067 4.80686 3.95711 5.06172 4.75 5.57143V5.57143L5.41667 6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M10 8.14286L6.93042 6.16956C5.3245 5.13718 4.52153 4.62099 3.85752 4.66841C3.27885 4.70974 2.74665 5.0003 2.39897 5.46471C2 5.99762 2 6.95219 2 8.86133V15.1387C2 17.0478 2 18.0024 2.39897 18.5353C2.74665 18.9997 3.27885 19.2903 3.85752 19.3316C4.52153 19.379 5.3245 18.8628 6.93042 17.8304L10 15.8571M19.8128 14.6918L14.9304 17.8304C13.3245 18.8628 12.5215 19.379 11.8575 19.3316C11.2789 19.2903 10.7466 18.9997 10.399 18.5353C10 18.0024 10 17.0478 10 15.1387V8.86133C10 6.95219 10 5.99762 10.399 5.46471C10.7466 5.0003 11.2789 4.70974 11.8575 4.66841C12.5215 4.62099 13.3245 5.13718 14.9304 6.16956L19.8128 9.30823C21.2063 10.2041 21.9031 10.652 22.1438 11.2216C22.3541 11.7192 22.3541 12.2808 22.1438 12.7784C21.9031 13.348 21.2063 13.7959 19.8128 14.6918Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 6.76932L6.18042 4.79602C4.5745 3.76364 3.77153 3.24745 3.10752 3.29488C2.52885 3.33621 1.99665 3.62677 1.64897 4.09117C1.25 4.62409 1.25 5.57866 1.25 7.48779V16.5126C1.25 18.4218 1.25 19.3763 1.64897 19.9093C1.99665 20.3737 2.52885 20.6642 3.10752 20.7055C3.77153 20.753 4.5745 20.2368 6.18042 19.2044L9.25 17.2311V6.76932Z"
				fill="currentColor"
			/>
			<path
				d="M13.5761 19.5929L21.1997 14.692C22.5933 13.7961 23.2901 13.3482 23.5307 12.7787C23.741 12.281 23.741 11.7194 23.5307 11.2218C23.2901 10.6522 22.5933 10.2043 21.1998 9.30845L21.1997 9.30844L13.5761 4.4075C12.4999 3.7157 11.9619 3.3698 11.5266 3.30902C10.6536 3.1871 9.80375 3.65109 9.43422 4.45137C9.25 4.85034 9.25 5.49 9.25 6.76932V17.2311C9.25 18.5104 9.25 19.1501 9.43422 19.5491C9.80374 20.3493 10.6536 20.8133 11.5266 20.6914C11.9619 20.6306 12.4999 20.2847 13.576 19.5929L13.5761 19.5929Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
